import { isNil } from "@instacover/utils"
import { useParams, useSearch } from "@tanstack/react-router"

import { SEARCH_PARAMS } from "../constants/urlParams"

export function useSessionId() {
  const { sessionId } = useParams({ from: "/$sessionId/_session" })
  return sessionId
}

export function useBacklink() {
  const search = useSearch({ from: "/$sessionId/_session" })
  const backlink = search[SEARCH_PARAMS.backlink]
  return isNil(backlink) || backlink === "" ? undefined : backlink
}
